import React from "react";
import { Button } from "@mui/material";

const WishlistItem = ({ item, showButton, onRemove, themeColor }) => {
  return (
    <div className="flex items-center bg-gray-100 p-4 rounded-md shadow-sm">
      <div className="w-[5rem] h-[5rem] lg:w-[7rem] lg:h-[7rem] rounded overflow-hidden">
        <img
          className="w-full h-full object-cover object-center"
          src={item?.imageUrl}
          alt={item?.title}
        />
      </div>

      <div className="ml-5 flex-1 space-y-1">
        <p className="text-lg font-semibold text-gray-800">{item?.title}</p>
        <p className="text-sm text-gray-500">Size: {item?.size || "N/A"}</p>
        <p className="text-sm text-gray-500">
          Seller: {item?.product?.brand || "Unknown"}
        </p>
        <div className="flex space-x-2 items-center pt-1">
          <p className="line-through text-gray-400 text-sm">
            ₹{item?.product?.price}
          </p>
          <p className="font-semibold text-base text-gray-800">
            ₹{item?.product?.discountedPrice}
          </p>
          <p className="text-green-600 font-semibold text-sm">
            {item?.product?.discountPersent}% off
          </p>
        </div>
      </div>

      {showButton && (
        <div className="ml-4">
          <Button
            size="small"
            variant="outlined"
            onClick={() => onRemove(item._id)}
            style={{
              color: themeColor,
              borderColor: themeColor,
            }}
          >
            Remove
          </Button>
        </div>
      )}
    </div>
  );
};

export default WishlistItem;
